import React from "react";
import Menu, { MenuItemProps } from "components/forms/Menu";
import routes from "components/routes";
import locationUtils from "utils/locationUtils";

export interface MenuProps {
  title?: string | undefined;
  items?: MenuItemProps[];
  actionArea?: JSX.Element;
}

const RegulationsMenu: React.FC<MenuProps> = function (props: MenuProps) {
  const sampleMenuItems: MenuItemProps[] = [
    {
      title: "BMR",
      to: routes.regulations.bmr,
      isActive: locationUtils.isRouteExactlyActive(routes.regulations.bmr)
    },
    {
      title: "ORDINANCES",
      to: routes.regulations.ordinances,
      isActive: locationUtils.isRouteExactlyActive(
        routes.regulations.ordinances
      )
    },
    {
      title: "RENT CONTROL",
      to: routes.regulations.rentControl,
      isActive: locationUtils.isRouteExactlyActive(
        routes.regulations.rentControl
      )
    },
    {
      title: "RENT CONTROL TYPES",
      to: routes.regulations.rentControlTypes,
      isActive: locationUtils.isRouteExactlyActive(
        routes.regulations.rentControlTypes
      )
    }
  ];

  return <Menu {...props} title="REGULATIONS" items={sampleMenuItems} />;
};

export default RegulationsMenu;
